






























































import { ElForm } from "element-ui/types/form";
import { Vue, Component, Prop, Ref } from "vue-property-decorator";

import SelectComponent from "../components/SelectComponent/index.vue";

import { USER_PROPERTY_TYPE } from "./config";

interface UserFormItem {
  label: string;
  propertyName: string;
  readonly: boolean;
  required: boolean;
}

@Component({
  name: "FileUpload",
  components: { SelectComponent }
})
export default class FileUpload extends Vue {
  private user = {
    value: "",
    text: "",
    propertyName: "",
    visible: false
  };

  @Ref("form")
  private elform!: ElForm;

  @Prop({
    required: true
  })
  config!: App.WebForm.ServiceOriginConfig;

  @Prop({
    required: true
  })
  private properties!: Array<{
    description: string;
    propertyName: string;
    reserved: boolean;
    propertyType: string;
  }>;

  @Prop({
    required: true
  })
  private main!: {
    propertyName: string;
    result: { type: string; value: string; object: any };
  };

  @Prop({
    required: true
  })
  private form!: any;

  private file: any = {};

  private users: { [prop: string]: { value: string; text: string } } = {};

  private onUserClick(item: UserFormItem) {
    if (item.readonly) return;

    this.user.propertyName = item.propertyName;
    this.user.text = this.users[item.propertyName].text;
    this.user.value = this.users[item.propertyName].value;
    this.user.visible = true;
  }

  getUserText(item: UserFormItem) {
    if (this.users[item.propertyName]) {
      return this.users[item.propertyName].text;
    }
    return "";
  }

  private userSelectConfirm(data: { text: string; valueText: string }) {
    this.users[this.user.propertyName].value = data.valueText;
    this.users[this.user.propertyName].text = data.text;
  }

  private get userList(): UserFormItem[] {
    const userList: UserFormItem[] = [];
    const auths = this.config.auths;
    this.properties.forEach((d) => {
      if (d.propertyType === USER_PROPERTY_TYPE) {
        const auth = auths[d.propertyName];
        if (auth.read) {
          userList.push({
            propertyName: d.propertyName,
            label: d.description,
            readonly: !auth.write,
            required: auth.required
          });
        }
      }
    });
    return userList;
  }

  onFileValidate(rule: any, value: any, callback: any) {
    if (!this.file || !this.file.fileId) {
      callback(new Error("请上传待审核文件"));
    } else {
      callback();
    }
  }

  onUserValidate(rule: any, value: any, callback: any, propertyName: string) {
    if (!this.users[propertyName].value) {
      callback(new Error(rule.message));
    } else {
      callback();
    }
  }

  /**
   * 构造必填选项 1、文件必须上传 2、设置了必填的人员字段
   */
  private get rules() {
    const rules: any = {};
    rules[this.main.propertyName] = {
      required: true,
      message: "请上传待审核文件",
      validator: (rule: any, value: any, callback: any) => {
        return this.onFileValidate(rule, value, callback);
      }
    };
    this.userList.forEach((d) => {
      if (d.required) {
        rules[d.propertyName] = {
          required: true,
          message: "请选择" + d.label,
          validator: (rule: any, value: any, callback: any) => {
            return this.onUserValidate(rule, value, callback, d.propertyName);
          }
        };
      }
    });
    return rules;
  }

  private reset() {
    this.file = {};
    this.userList.forEach((d) => {
      this.users[d.propertyName] = {
        value: "",
        text: ""
      };
    });
  }

  onUploadSuccess(res: any) {
    if (res.success) {
      this.file = res.data;
    }
  }

  onUploadError(e: any) {
    console.log(e);
  }

  beforeUpload(e: any) {
    console.log(e);
  }

  onRemove() {
    this.reset();
  }

  mounted() {
    this.reset();
  }

  getFormValues(): Promise<{ valid: boolean; data: any }> {
    return new Promise((resolve) => {
      this.elform.validate((valid) => {
        if (!valid) {
          resolve({ valid: false, data: null });
        } else {
          const form = JSON.parse(JSON.stringify(this.form));
          form[this.main.propertyName].value = this.file.fileId;
          for (let propertyName in this.users) {
            form[propertyName].value = this.users[propertyName].value;
          }
          resolve({ valid: true, data: form });
        }
      });
    });
  }
}
